import { render, staticRenderFns } from "./SelectDistrict.vue?vue&type=template&id=d81d9c90&"
import script from "./SelectDistrict.vue?vue&type=script&lang=js&"
export * from "./SelectDistrict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports